<template>
  <div class="smd-checkbox__row" @click="toggleCheckbox">

    <div class="smd-checkbox">
      <input type="checkbox" :checked="isChecked" :disabled="disabled">
      <span></span>
    </div>

    <p v-if="hasSlot">
      <slot/>
    </p>


  </div>
</template>

<script>
  import {smartAdd, smartRemove, smartHas} from "../utilities/utilityOperators";

  export default {
    name: "smd-checkbox",
    props: {
      id: {required:true},
      value:{required:true},
      disabled: {type:Boolean, default: false},
      data:{},
      replaceValue:{type:Boolean, default:true}
    },
    data() {
      return {
        internalData: this.data || this.id
      }
    },
    computed: {
      isChecked() {
        return smartHas(this.value)(this.id)(this.internalData)
      },
      hasSlot(){
        return !!this.$slots.default;
      }
    },
    methods:{
      emitData(checkValue) {
        let payload = this.replaceValue
          ? (checkValue ? smartAdd(this.value)(this.id)(this.internalData)
                        : smartRemove(this.value)(this.id)(this.internalData))
          : {id:this.id, value:checkValue, data: this.internalData};
        this.$emit('input', payload);
      },
      toggleCheckbox() {
        if (!this.disabled) {
          return this.emitData(!this.isChecked)
        } else {
          return false;
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "scss/pogs-util";

  $size: 21px;

  .smd-checkbox{
    @extend %independent-layout-container;

    height: $size;
    width: $size;

    input[type="checkbox"]{
      @extend %independent-layout;
      cursor: pointer;

      opacity: 0;

      height: $size;
      width: $size;

      z-index: 1000;

       & + span:before {
         @extend %independent-layout, %border-sides-radius-circle;

         border-color: color(dark, border);
         content:' ';

         height: $size;
         width: $size;
       }

      &:checked + span:after{
        @extend %independent-layout;

         content: "\e908";
         color: color(base);

         font-family: 'seriousmd';
         font-size: 22px;

         top: -1px;
       }
    }
  }

  .smd-checkbox__row{
    @extend %flex-row--center-x, %user-no-select;
    @include space-me($t:m, $b: m);

    cursor: pointer;

    p{
      @include space-me($t: m, $b: m);
      @include space-me($t: m, $b: m, $prop: margin, $key: reset);
      font-weight: font(medium-bold);
      flex: 1;
    }

    .smd-checkbox{
      align-self: flex-start;

      & + p{
        @include space-me($prop: margin, $l: s);
      }
    }
  }
</style>
